var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95713 9.29291C6.5666 8.90239 5.93344 8.90239 5.54291 9.29291C5.15239 9.68344 5.15239 10.3166 5.54291 10.7071L6.95713 9.29291ZM8.75002 12.5L8.04291 13.2071C8.43344 13.5977 9.0666 13.5977 9.45713 13.2071L8.75002 12.5ZM14.4571 8.20713C14.8477 7.8166 14.8477 7.18344 14.4571 6.79291C14.0666 6.40239 13.4334 6.40239 13.0429 6.79291L14.4571 8.20713ZM17.3334 10C17.3334 14.0501 14.0501 17.3334 10 17.3334V19.3334C15.1547 19.3334 19.3334 15.1547 19.3334 10H17.3334ZM10 17.3334C5.94993 17.3334 2.66669 14.0501 2.66669 10H0.666687C0.666687 15.1547 4.84536 19.3334 10 19.3334V17.3334ZM2.66669 10C2.66669 5.94993 5.94993 2.66669 10 2.66669V0.666687C4.84536 0.666687 0.666687 4.84536 0.666687 10H2.66669ZM10 2.66669C14.0501 2.66669 17.3334 5.94993 17.3334 10H19.3334C19.3334 4.84536 15.1547 0.666687 10 0.666687V2.66669ZM5.54291 10.7071L8.04291 13.2071L9.45713 11.7929L6.95713 9.29291L5.54291 10.7071ZM9.45713 13.2071L14.4571 8.20713L13.0429 6.79291L8.04291 11.7929L9.45713 13.2071Z",
    fill: "#529C83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e7f739c0981761b5de23b21badc62cc6.svg";
export { ForwardRef as ReactComponent };